// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"070bb9d9","116":"137e110a","957":"4c0d160e"}[chunkId] + ".chunk.css";
};